<template>
  <div class="header-auth">
    <div class="header-auth__logo">
      <img src="@/assets/logo.svg" alt="" />
    </div>
  </div>
</template>

<script>
  export default {};
</script>

<style lang="sass" scoped>
.header-auth
  padding-left: 40px
  padding-right: 40px
  margin-top: 20px
  margin-bottom: 66px
  &__logo
    width: 105px
    opacity: 0
    img 
      width: 100%
      height: auto

@media screen and ( max-width: 630px)
  .header-auth
    padding-left: 15px
</style>
